<!-- page content start -->
<ion-header class="header" mode="md">
  <ion-grid fixed class="ion-no-padding">
    <ion-toolbar mode="md">
      <ion-title class="logo-container" slot="start" style="padding-left:10px"><img style="margin-top:0px;" src="/assets/logos/gourmet-slovenia.png"></ion-title>
      <!--app-top-right slot="end"></app-top-right-->
      <ion-buttons slot="end">
  
      <!--<ion-button>
        <ion-icon class="profile"></ion-icon>
      </ion-button>-->

        <ion-select interface="action-sheet" [selectedText]="translateService.currentLang.toUpperCase()" style="padding-left:5px; max-width:100%; color: black; font-size: small;" [ngModel]="translateService.currentLang" (ionChange)="onChange($event)">
        <ion-select-option value="sl">SL - Slovenščina</ion-select-option>
        <ion-select-option value="en">EN - English</ion-select-option>
        <ion-select-option value="de">DE - Deutsch</ion-select-option>
        <ion-select-option value="it">IT - Italiano</ion-select-option>
        <!--ion-select-option value="hr">HR - Hrvatski</ion-select-option-->
        </ion-select>

        <!--ion-menu-button slot="end" autoHide="false"></ion-menu-button-->

      <!--<ion-button (click)="logout($event)">Odjava</ion-button>-->

      

      </ion-buttons>

    </ion-toolbar>
  </ion-grid>
</ion-header>

<!--ion-content style="--background: no-repeat center/cover url('../assets/images/gourmet-slovenia-1.jpg');" -->
<ion-content style="--background: url(/assets/images/gourmet-slovenia-2.jpg)  no-repeat bottom/cover fixed;">

  <div class="content-container">
    <app-countdown></app-countdown>
  </div>

  
</ion-content>

<app-footer style="border-top:3px solid white;">
</app-footer>

